//src/web/Advertisement/Admin/AdRegistration.tsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdvertiserOnboardingLayout from "./AdvertiserOnboardingLayout";
import api from "../../../shared/api/axios";

type AccountType = "business" | "individual";

const AdRegistration: React.FC = () => {
  const navigate = useNavigate();

  const [accountType, setAccountType] = useState<AccountType>("business");
  const [legalName, setLegalName] = useState("");
  const [vatId, setVatId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const canContinue = legalName.trim().length > 2;

  const handleContinue = async () => {
    if (!canContinue || loading) return;

    setLoading(true);
    setError(null);

    try {
      await api.post("/advertiser/register-draft", {
        accountType,
        legalName,
        vatId: accountType === "business" ? vatId || null : null,
      });

      navigate("/billing");
    } catch (e: any) {
      setError(
        e?.response?.data?.msg ||
          "Failed to save advertiser information."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdvertiserOnboardingLayout>
      <header style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 26, marginBottom: 6 }}>
          Advertiser information
        </h1>
        <p style={{ fontSize: 14, color: "#9ca3af" }}>
          Tell us who will be billed for advertising spend.
        </p>
      </header>

      {error && (
        <div
          style={{
            background: "rgba(127,29,29,0.3)",
            padding: 12,
            borderRadius: 10,
            marginBottom: 16,
          }}
        >
          {error}
        </div>
      )}

      <section
        style={{
          background: "#0D101B",
          border: "1px solid #22283a",
          borderRadius: 16,
          padding: 20,
        }}
      >
        {/* Account type */}
        <label style={label}>Account type</label>
        <select
          value={accountType}
          onChange={(e) =>
            setAccountType(e.target.value as AccountType)
          }
          style={input}
        >
          <option value="business">Business</option>
          <option value="individual">Individual</option>
        </select>

        {/* Legal name */}
        <label style={label}>
          {accountType === "business"
            ? "Company legal name"
            : "Full legal name"}
        </label>
        <input
          value={legalName}
          onChange={(e) => setLegalName(e.target.value)}
          style={input}
        />

        {/* VAT */}
        {accountType === "business" && (
          <>
            <label style={label}>VAT / Tax ID (optional)</label>
            <input
              value={vatId}
              onChange={(e) => setVatId(e.target.value)}
              style={input}
            />
          </>
        )}
      </section>

 <footer
  style={{
    marginTop: 24,
    display: "flex",
    justifyContent: "flex-end",
    gap: 10, // 👈 small space between buttons
  }}
>
  {/* Skip */}
  <button
    type="button"
    onClick={() => navigate("/advertisementstart")}
    style={{
      padding: "10px 16px",
      borderRadius: 999,
      border: "1px solid #4b5563",
      background: "transparent",
      color: "#e5e7eb",
      cursor: "pointer",
    }}
  >
    Skip for now
  </button>

  {/* Continue */}
  <button
    onClick={handleContinue}
    disabled={!canContinue || loading}
    style={{
      padding: "10px 20px",
      borderRadius: 999,
      background: "#22c55e",
      color: "#020617",
      fontWeight: 600,
      border: "none",
      opacity: !canContinue || loading ? 0.6 : 1,
      cursor: "pointer",
    }}
  >
    {loading ? "Saving…" : "Continue"}
  </button>
</footer>


    </AdvertiserOnboardingLayout>
  );
};

export default AdRegistration;

const label = {
  display: "block",
  fontSize: 13,
  color: "#9ca3af",
  marginTop: 12,
  marginBottom: 4,
};

const input = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #374151",
  background: "#020617",
  color: "#e5e7eb",
};
